<template lang="html">
  <section id="newsletter" class="no-pad">
    <h1 class="no-pad">Newsletter</h1>
    <form action="https://aha-festival.us20.list-manage.com/subscribe/post?u=f61bc318c8b6d3429d69fea3b&amp;id=fe519af25c" method="post" class="validate aha-newsletter" target="_blank" novalidate>
      <input type="email" value="" name="EMAIL" class="email" placeholder="Email" required>
      <!-- <button type="button" name="button">Abonnieren</button> -->
      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_f61bc318c8b6d3429d69fea3b_fe519af25c" tabindex="-1" value=""></div>
      <input v-if="this.$route.name !== 'english'" type="submit" value="Abonnieren" name="button" class="button">
      <input v-else type="submit" value="Subscribe" name="button" class="button">
    </form>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/base';
.aha-newsletter {
    input {
        border: 0;
        width: 100%;
        font-family: $font-family;
        font-size: $font-size;
        padding: $gap / 4 0;
        border: 0;
        border-bottom: 2px solid $font-color;
        appearance: none;
        color: $font-color;
        background: transparent;
        border-radius: 0;
        &::placeholder {
            color: $color2;
        }
        @media only screen and (max-width: $phone) {
            font-size: $font-size / 2;
            border-bottom: 1px solid $font-color;
            padding: $gap / 2 0;
        }
        &.button {
            border: 0;
            text-align: left;
            font-family: $font-family;
            font-size: $font-size;
            padding: 0;
            padding: $gap / 4 0 0 0;
            cursor: pointer;
            width: auto;
            color: $font-color;
            border-bottom: 2px solid $bgcolor;
            @media only screen and (max-width: $phone) {
                font-size: $font-size / 2;
                padding: $gap / 2 0 0 0;
            }
            &:hover {
                border-bottom: 2px solid $font-color;
            }
            &:focus {
                outline: none;
            }
        }
        &:focus {
            outline: none;
        }
    }
}
</style>
